import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Zap } from 'lucide-react';
const costData = [{
  without: '3 visitas de electricista por año',
  cost: '$75.000-$150.000 que podrías evitar'
}, {
  without: 'Diferencial que salta de madrugada',
  cost: 'Pánico + urgencia + $50.000'
}, {
  without: 'Circuito del aire mal instalado',
  cost: 'Técnico + materiales + $80.000-$150.000'
}, {
  without: 'Tablero sin etiquetar',
  cost: 'Corte incorrecto en emergencia'
}, {
  without: 'Sin diagnóstico de fallas',
  cost: 'Problema crónico que empeora con el tiempo'
}, {
  without: 'Sin legajo técnico',
  cost: 'Propiedad sin documentación técnica de valor'
}];
export function CostTable() {
  return <section className="py-14 bg-graphite relative" data-id="element-74">
      <div className="container mx-auto px-4" data-id="element-75">
        <div className="text-center mb-8" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold flex items-center justify-center gap-3" data-id="element-77">
            <span className="text-2xl" data-id="element-78">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="max-w-3xl mx-auto mb-10" data-id="element-79">
          <div className="bg-petroleum border border-red-500/20 rounded-2xl overflow-hidden" data-id="element-80">
            <table className="w-full text-left border-collapse" data-id="element-81">
              <thead data-id="element-82">
                <tr data-id="element-83">
                  <th className="p-5 border-b border-white/10 text-textsecondary font-medium" data-id="element-84">
                    Sin el Manual
                  </th>
                  <th className="p-5 border-b border-white/10 text-red-400 font-medium flex items-center gap-2" data-id="element-85">
                    <AlertTriangle className="w-4 h-4" data-id="element-86" /> Costo real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-87">
                {costData.map((row, i) => <tr key={i} className="border-b border-white/5 last:border-0" data-id="element-88">
                    <td className="p-5 text-white font-medium" data-id="element-89">
                      {row.without}
                    </td>
                    <td className="p-5 text-red-300" data-id="element-90">{row.cost}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-91">
          <p className="text-xl text-textsecondary mb-4" data-id="element-92">
            El próximo fin de semana puede ser diferente.
          </p>
          <h3 className="text-2xl md:text-4xl font-extrabold text-gold flex items-center justify-center gap-3" data-id="element-93">
            "La próxima falla eléctrica puede ser la que resolvés vos solo."{' '}
            <Zap className="w-8 h-8 fill-gold" data-id="element-94" />
          </h3>
        </motion.div>
      </div>
    </section>;
}